import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FilterCampaignComponent } from './filter-campaign/filter-campaign.component';
import * as moment from "moment";
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { DashboardService } from '../../services/dashboard.service';
import { CommonUtilService } from '../../services/common-util.service';
import { ColumnApi, GridApi, GridOptions } from "ag-grid-community";
import { EditComponent } from '../sharedComponent/edit/edit.component';
import { SwitchToggleComponent } from '../sharedComponent/switch-toggle/switch-toggle.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CampaignService } from '../../services/campaign.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { HardcodedData } from '../hardcoded-data';
import { ClientSideStorageService } from 'src/app/services/client-side-storage.service';
import { ViewComponent } from '../sharedComponent/view/view.component';
import { NotificationAlertService } from 'src/app/services/notification-alert.service';
import { CreateflashdealComponent } from '../sharedComponent/createflashdeal/createflashdeal.component';
import { environment } from 'src/environments/environment';
import { NgbDatepicker, NgbDateStruct, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { defaultConfig } from 'src/config/default-config';
import { coteivoryConfig } from 'src/config/Cote-ivory-config';
import { zimConfig } from 'src/config/zim-config';
import { botswanaConfig } from 'src/config/botswana-config';
import { catchError, of, switchMap } from 'rxjs';
declare var Stripe: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {
  placeholders = environment.placeholders as { [key: string]: string };
  isComingFromSource = false;
  gridOptions = <GridOptions>{};
  gridApi: any;
  gridColumnApi: any;
  frameworkComponents: any;
  columnDefs: any;
  header: any;
  id: any;
  defaultColDef = {};
  paginationPageSize: any;
  currentPage: any;
  isPageChanged: any;
  types = [10, 20, 30];
  paramsSelectRecord = {
    type: "gridReady",
    api: GridApi,
    columnApi: ColumnApi,
  };
  minRowHeight = 25;
  data: any = [];
  loanFilter: any;
  presentDate: any;
  past15Days: any;
  pastMonthDay: any;
  pastWeek: any;
  past3Month: any;
  currentDate: any;
  datePickerInput: any;
  fromDate: any;
  toDate: any;
  datePickerVisible = false;
  activePage: number = 1;
  dropdownSettings: IDropdownSettings = {};
  dashboardForm: FormGroup = new FormGroup({
    dateFilter: new FormControl('3'),
    totalCampaign: new FormControl(''),
    totalBudget: new FormControl(''),
    actualSpent: new FormControl(''),
    search: new FormControl(''),
  });
  allCategory: any;
  categoryValue: any;
  dashboardData = new HardcodedData();
  campaignTotalData: any;
  searchValue: any;
  dateFilter: any;
  userData: any;
  currencyData: any;
  filterDataForChip: any;
  todaysDate: any;
  minDate: any;
  recordTotalCount: any = 0;
  placeHolders: any;
  currency: any;
  isNewUser: any;
  isCharge: any;
  reportPlaceHolders: any;
  receiptlogo: any;
  dashName: any;
  personID: any
  userEmail: any;
  showAlert = false;


  @ViewChild('addFundsModal') addFundsModal!: ElementRef;
  @ViewChild('cardElement', { static: false }) cardElement!: ElementRef;
  constructor(private router: Router, private route: ActivatedRoute, public dialog: MatDialog, private dashboardService: DashboardService, private service: CommonUtilService, private notifyService: NotificationAlertService,
    private commonUtilService: CommonUtilService, private modalService: NgbModal, private fb: FormBuilder, private campaignService: CampaignService, private clientStorage: ClientSideStorageService, @Inject('COUNTRY_CONFIG') private countryConfig: any) {

    if (environment.authUrl.toLowerCase().includes('app.ship2myid.com')) {
      this.isProd = false;
    }
    this.placeHolders = this.placeholders['dashboard_page']
    this.reportPlaceHolders = this.placeholders['Reports_page']
    const postValue = this.clientStorage.get('postcountry') ?? history.state.countryConfig.country
    this.countryConfig = this.getConfigByCountry(postValue) ?? defaultConfig;
    this.receiptlogo = this.countryConfig.loginPostlogo;
    this.currency = this.countryConfig.currency;
    this.isNewUser = sessionStorage.getItem('isNewUser') === 'true' ? true : false;
    this.campaignService.setData(null);
    const curDate = new Date();
    this.todaysDate =
      curDate.getFullYear() +
      "-" +
      ("0" + (curDate.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + curDate.getDate()).slice(-2);

    const minDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 1);
    this.minDate = minDate.toISOString().split('T')[0];

    // Below call to get from State for Company data 

    // this.service.getRegisterCompanyDetails().subscribe((res: any) => {

    //   if (res?.data) {
    //     this.userData = res?.data;
    //     this.clientStorage.set('marketplaceData', JSON.stringify(this.userData));
    //   }
    // });
    this.route.data.subscribe((data: any) => {
      this.allCategory = data?.resolvedData.data;
      this.dashboardService.setData(data?.resolvedData);
    });

    this.userData = JSON.parse(this.clientStorage.get("marketplaceData"));
    // this.isCharge = this.userData.final_payment_flag
    // this.dashName = JSON.parse(this.clientStorage.get("userFullName"))
    this.personID = JSON.parse(this.clientStorage.get("userId"));
    this.userEmail = JSON.parse(this.clientStorage.get("userName"));

    this.dashName = this.safeParse(this.clientStorage.get("userFullName"));
    // this.personID = this.safeParse(this.clientStorage.get("userId"));
    // this.userEmail = this.safeParse(this.clientStorage.get("userName"));
    this.isCharge = (
      (this.userData?.paymentMode === 'WALLET' && this.userData?.final_payment_flag) ||
      (this.userData?.paymentMode === 'CARD' && this.userData?.final_payment_flag && this.userData?.stripeCustomerId)
    );
    this.loadWallet();
    // if (this.userData) {
    //   this.campaignService.eventCostByCountry(this.userData['country']).subscribe((response: any) => {
    //     if (response?.body?.data?.countryEventsCostList) {
    //       this.currencyData = response?.body?.data?.countryEventsCostList[0];
    //     }
    //   });
    // }
    this.dateFilter = '3';
    this.createDashboardForm();
    this.dropdownSettings = {
      idField: "category_id",
      textField: "category_type",
      enableCheckAll: true,
      // selectAllText: "Select All Users From List",
      // unSelectAllText: "Unselect All Users From List",
      noDataAvailablePlaceholderText: "There is no item availabale to show",
      allowSearchFilter: true,
      itemsShowLimit: 1,
      // defaultOpen: false
    };
    // this.getBrandSpecificCategory();
    this.getCategory();
    this.currentDate = new Date();
    // this.presentDate =
    // this.currentDate.getFullYear() +
    //   "-" +
    //   ("0" + (this.currentDate.getMonth() + 1)).slice(-2) +
    //   "-" +
    //   ("0" + this.currentDate.getDate()).slice(-2);

    let parsedDate = moment(this.currentDate, "YYYY-MM-DD");
    this.presentDate = parsedDate.format("MM/DD/YYYY");
    this.toDate = this.presentDate;
    // this.createDashboardForm();
    const today = new Date();

    // To Date = today
    this.toDate1 = {
      year: today.getFullYear(),
      month: today.getMonth() + 1, // JS months are 0-based
      day: today.getDate()
    };

    // From Date = 1 month before
    const prevMonth = new Date(today);
    prevMonth.setMonth(today.getMonth() - 1);

    this.fromDate1 = {
      year: prevMonth.getFullYear(),
      month: prevMonth.getMonth() + 1,
      day: prevMonth.getDate()
    };
    // this.dateFilter = '3';
    this.filterDetails();
    this.defaultColDef = this.commonUtilService.getDefaultColumnDef();
    this.gridOptions.defaultColDef = this.defaultColDef;
    this.createColumnDefs();
    this.gridOptions.columnDefs = this.columnDefs;
    this.gridOptions.rowHeight = 51;


  }
  isProd: boolean = true;

  amount: number = 0;
  paymentMethod: string = '';

  openAddFundsModal(content: any) {
    this.modalService.open(content, { centered: true, size: 'md' });
    this.initializeStripe()
  }

  addFunds1(modal: any) {

    if (!this.amount || !this.paymentMethod) {
      alert('Please enter amount and select a payment method.');
      return;
    }

    console.log('Funds Added:', {
      amount: this.amount,
      method: this.paymentMethod
    });

    // Reset form fields after submit
    this.amount = 0;
    this.paymentMethod = '';

    modal.close('funds-added');
  }

  getConfigByCountry(country: string): any {
    switch (country) {
      case 'Botswana':
        return botswanaConfig;
      case 'Zimbabwe':
        return zimConfig;
      case 'Cote De Ivory':
        return coteivoryConfig;
      default:
        return defaultConfig;
    }
  }
  ngOnInit(): void {


    this.defaultColDef = {
      editable: true,
      sortable: true,
      minWidth: 100,
      filter: true,
      resizable: false,
      tooltip: false,
      width: 170,

    };
    // this.getTableData(this.past15Days, this.presentDate, '1');
    // this.route.params.subscribe(params => {
    //   this.isComingFromSource = params['isComingFromSource'] === 'true';
    // });

    const routeSnapshot: ActivatedRouteSnapshot = this.router.routerState.snapshot.root;
    this.isComingFromSource = true //this.checkIsComingFromSource(routeSnapshot);
  }

  private checkIsComingFromSource(routeSnapshot: ActivatedRouteSnapshot): boolean {
    // Add your logic to check if the flag is set in route parameters or query parameters
    const isComingFromSource = routeSnapshot.firstChild?.params['isComingFromSource'] === 'true';
    return isComingFromSource;
  }

  createDashboardForm() {
    // if (this.campaignTotalData !== null && this.campaignTotalData !== undefined) {
    //   let res = this.campaignTotalData;
    //   this.dashboardForm = this.fb.group({
    //     dateFilter: [this.dateFilter],
    //     totalCampaign: [res?.TOTAL_DEALS],
    //     totalBudget: [res?.TOTAL_BUDGET],
    //     actualSpent: [res?.TOTAL_ACTUAL_SPENT],
    //     pagination: [this.activePage],
    //     search: [''],
    //     toDate: [this.toDate],
    //     fromDate: [this.fromDate],
    //     filterStatus: [''],
    //     filterbudget: [''],
    //     filterSpent: [''],
    //     categories: ['']
    //   });
    // } else {
    this.dashboardForm = this.fb.group({
      dateFilter: [this.dateFilter],
      totalCampaign: new FormControl(),
      totalBudget: new FormControl(),
      actualSpent: new FormControl(),
      pagination: [this.activePage],
      search: [''],
      toDate: [this.toDate],
      fromDate: [this.fromDate],
      filterStatus: [''],
      filterbudget: [''],
      filterSpent: [''],
      categories: ['']
    }
    );
    // }
  }

  getCampaignTotalData(fromDate: any, toDate: any) {
    this.campaignTotalData = null;
    // this.dashboardService.campaignData(fromDate, toDate, this.userData.marketplace_id).subscribe((res: any) => {
    // this.campaignTotalData = res;
    // this.createDashboardForm();
    this.dashboardForm.value.fromDate = fromDate;
    this.dashboardForm.value.toDate = toDate;
    // this.activePage = 0;
    // this.dashboardForm.value.pagination = '1';
    setTimeout(() => {
      // Code to execute after 2 seconds
      this.getTableData();
    }, 0);

    // });
  }

  // onResetFilter() {
  //   this.dashboardForm.controls["category"].reset();
  //   this.dashboardForm.controls["status"].reset();
  // }

  // onSubmitFilter() {//method not used any more
  //   // this.fromDate, this.toDate
  //   let res = this.dashboardForm.value;
  //   if (res.dateFilter === 2) {
  //     this.getTableData(this.pastWeek, this.presentDate, '1', res.status);
  //   } else if (res.dateFilter === 3) {
  //     this.getTableData(this.past15Days, this.presentDate, '1', res.status);
  //   } else if (res.dateFilter === 4) {
  //     this.getTableData(this.pastMonthDay, this.presentDate, '1', res.status);
  //   } else if (res.dateFilter === 5) {
  //     this.getTableData(this.past3Month, this.presentDate, '1', res.status);
  //   } else if (res.dateFilter === 1) {
  //     if ((this.fromDate !== null && this.fromDate !== undefined) && (this.toDate !== null && this.toDate !== undefined) && (res.status !== null && res.status !== undefined)) {
  //       this.getTableData(this.fromDate, this.toDate, '1', res.status);
  //     }
  //   }
  //   // this.getTableData(filterData.fromDate, filterData.toDate, '1', filterData.status)
  // }

  getCategory() {
    this.dashboardService.getCategory().subscribe((response: any) => {
      // this.commonUtilService.tokenSet(response);
      this.allCategory = response?.body.data;
      this.dashboardService.setData(response?.body);
    });
  }

  getBrandSpecificCategory() {
    this.dashboardService.getBrandCategory(this.userData.marketplace_id).subscribe((response: any) => {
      // this.commonUtilService.tokenSet(response);
      this.allCategory = response?.body.data;
      this.dashboardService.setData(response?.body);
    });
  }

  getTableData() {
    // let fromDate = this.dashboardForm.value.fromDate;
    // let toDate = this.dashboardForm.value.toDate;
    // let pageNumber = this.dashboardForm.value.pagination;
    // let status = this.dashboardForm.value.filterStatus;

    this.data = [];
    // if (status === "All") {
    //   status = "All";
    // } else if (status === '') {
    //   status = "A";
    // }
    this.activePage = 1;
    this.dashboardService.getBrandSpecificDeals(this.dashboardForm.value, this.userData.marketplace_id).subscribe((res: any) => {
      this.commonUtilService.tokenSet(res);
      this.recordTotalCount = 0;
      this.campaignTotalData = res?.body?.data;
      //this.createDashboardForm();
      this.recordTotalCount = res?.body?.data?.TOTAL_DEALS;
      if (res && res?.body.data && res?.body.data.DEALS && res?.body.data.DEALS.length !== 0) {
        res?.body.data.DEALS.forEach((item: any) => {
          let tableData = item;
          // if (item && item.categories[0]) {
          //   // let data = this.allCategory?.find((i: any) => i.category_id === item.categories[0]);
          //   // tableData.category_type = data?.category_type;
          //   let parsedDate = moment(tableData.created_date, "YYYY-MM-DD");
          //   tableData.created_date = parsedDate.format("DD/MM/YYYY");
          //   this.data.push(tableData);
          // }
          if (item && item.categories) {
            let categoryTypes: string[] = [];
            item.categories.forEach((categoryId: number) => {
              let data = this.allCategory?.find((i: any) => i.category_id === categoryId);
              if (data) {
                categoryTypes.push(data.category_type);
              }
            });
            let parsedDate = moment(tableData.created_date, "YYYY-MM-DD");
            tableData.created_date = parsedDate.format("DD/MM/YYYY");
            tableData.category_type = categoryTypes.join(', ');
            this.data.push(tableData);
          }
        });
        this.createColumnDefs();
        this.dashboardForm.get('totalCampaign')?.setValue(this.campaignTotalData?.TOTAL_DEALS);
        this.dashboardForm.get('totalBudget')?.setValue(this.campaignTotalData?.TOTAL_BUDGET);
        this.dashboardForm.get('actualSpent')?.setValue(this.campaignTotalData?.TOTAL_ACTUAL_SPENT);
      } else {
        this.createColumnDefs();
        this.dashboardForm.get('totalCampaign')?.setValue(this.campaignTotalData?.TOTAL_DEALS);
        this.dashboardForm.get('totalBudget')?.setValue(this.campaignTotalData?.TOTAL_BUDGET);
        this.dashboardForm.get('actualSpent')?.setValue(this.campaignTotalData?.TOTAL_ACTUAL_SPENT);
      }
    }, (error) => {

      //this.data = this.dashboardData.AllCampaignTestData;
    });
  }


  setCategoryValue(e: any) {
    debugger//method not used any more
    this.categoryValue = e;
  }

  lastWeekData() {
    this.filterDataForChip = null;
    this.datePickerVisible = false;
    const pastWeek = new Date(
      new Date().getTime() - 6 * 24 * 60 * 60 * 1000
    );
    this.dateFilter = '2';
    let parsedDate = moment(pastWeek, "YYYY-MM-DD");
    this.pastWeek = parsedDate.format("MM/DD/YYYY");
    this.dashboardForm.value.fromDate = this.pastWeek;
    this.dashboardForm.value.toDate = this.presentDate;
    this.toDate = this.presentDate;
    this.fromDate = this.pastWeek;
    this.dashboardForm.get('toDate')?.setValue(this.toDate);
    this.dashboardForm.get('fromDate')?.setValue(this.fromDate);
    this.dashboardForm.get('pagination')?.setValue('1');
    this.dashboardForm.get('dateFilter')?.setValue(this.dateFilter);
    // this.dashboardForm.controls["pagination"].reset();
    this.getCampaignTotalData(this.pastWeek, this.presentDate);
  }

  last15DaysData() {
    this.filterDataForChip = null;
    this.datePickerVisible = false;
    const past15Days = new Date(
      new Date().getTime() - 14 * 24 * 60 * 60 * 1000
    );
    this.dateFilter = '3';
    let parsedDate = moment(past15Days, "YYYY-MM-DD");
    this.past15Days = parsedDate.format("MM/DD/YYYY");
    this.dashboardForm.value.fromDate = this.past15Days;
    this.dashboardForm.value.toDate = this.presentDate;
    this.toDate = this.presentDate;
    this.fromDate = this.past15Days;
    this.dashboardForm.get('toDate')?.setValue(this.toDate);
    this.dashboardForm.get('fromDate')?.setValue(this.fromDate);
    this.dashboardForm.get('pagination')?.setValue('1');
    this.dashboardForm.get('dateFilter')?.setValue(this.dateFilter);
    this.dashboardForm.get('search')?.setValue('');
    // this.dashboardForm.controls["pagination"].reset();
    this.getCampaignTotalData(this.past15Days, this.presentDate);
    // this.getTableData(this.past15Days, this.presentDate);
  }

  lastMonthData() {
    this.filterDataForChip = null;
    this.datePickerVisible = false;
    const pastMonthDay = new Date(
      new Date().getTime() - 29 * 24 * 60 * 60 * 1000
    );
    this.dateFilter = '4';
    let parsedDate = moment(pastMonthDay, "YYYY-MM-DD");
    this.pastMonthDay = parsedDate.format("MM/DD/YYYY");
    this.dashboardForm.value.fromDate = this.pastMonthDay;
    this.dashboardForm.value.toDate = this.presentDate;
    this.toDate = this.presentDate;
    this.fromDate = this.pastMonthDay;
    this.dashboardForm.get('toDate')?.setValue(this.toDate);
    this.dashboardForm.get('fromDate')?.setValue(this.fromDate);
    this.dashboardForm.get('pagination')?.setValue('1');
    this.dashboardForm.get('dateFilter')?.setValue(this.dateFilter);
    // this.dashboardForm.controls["pagination"].reset();
    this.getCampaignTotalData(this.pastMonthDay, this.presentDate);
  }

  last3MonthData() {
    this.filterDataForChip = null;
    this.datePickerVisible = false;
    const past3Month = new Date(
      new Date().getTime() - 89 * 24 * 60 * 60 * 1000
    );
    this.dateFilter = '5';
    let parsedDate = moment(past3Month, "YYYY-MM-DD");
    this.past3Month = parsedDate.format("MM/DD/YYYY");
    this.dashboardForm.value.fromDate = this.past3Month;
    this.dashboardForm.value.toDate = this.presentDate;
    this.toDate = this.presentDate;
    this.fromDate = this.past3Month;
    this.dashboardForm.get('toDate')?.setValue(this.toDate);
    this.dashboardForm.get('fromDate')?.setValue(this.fromDate);
    this.dashboardForm.get('pagination')?.setValue('1');
    this.dashboardForm.get('dateFilter')?.setValue(this.dateFilter);
    // this.dashboardForm.controls["pagination"].reset();
    this.getCampaignTotalData(this.past3Month, this.presentDate);
  }

  onGridReady(params: any, value?: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (value && value !== null && value !== undefined) {
      this.paginationPageSize = value;
      this.ngOnInit();
    } else {
      this.paginationPageSize = 10;
    }
  }

  // quickSearch(e: any) {
  //   // if (e.target.value.length >= 3 || e.target.value.length === 0) {
  //   this.gridApi.setQuickFilter(e.target.value);
  //   // }
  // }

  searchClick(event: any) {//method not used any more
    this.gridApi.setQuickFilter(event.target.value);
  }

  createColumnDefs() {
    this.columnDefs = [];
    let header: any;

    this.frameworkComponents = {
      // toggleComponent: ToggleComponent,
      edit: EditComponent,
      // cellRendererFramework: RouterLinkRendererComponentComponent
    };

    header = this.commonUtilService.getColumnHeader(
      "uuid",
      'Unique ID'
    );
    header.filterParams = this.commonUtilService.getFilterButtons();
    header.filter = false;
    header.minWidth = 100;
    header.filterParams.suppressAndOrCondition = true;
    header.filterParams.filterOptions =
      this.commonUtilService.getCommaSeparatedFilter();
    this.columnDefs.push(header);

    header = this.commonUtilService.getColumnHeader(
      "product_name",
      this.placeHolders['LBL_TBL_NAME']
    );
    header.filterParams = this.commonUtilService.getFilterButtons();
    header.filterParams.suppressAndOrCondition = true;
    header.minWidth = 200;
    // header.wrapText= true;
    header.filterParams.filterOptions =
      this.commonUtilService.getCommaSeparatedFilter();
    this.columnDefs.push(header);

    header = this.commonUtilService.getColumnHeader(
      "created_by",
      'Created By'
    );
    header.filterParams = this.commonUtilService.getFilterButtons();
    header.filter = false;
    header.minWidth = 120;
    header.filterParams.suppressAndOrCondition = true;
    header.filterParams.filterOptions =
      this.commonUtilService.getCommaSeparatedFilter();
    this.columnDefs.push(header);

    header = this.commonUtilService.getColumnHeader(
      "created_date",
      this.placeHolders['LBL_TBL_DATE_CREATED']
    );
    header.filterParams = this.commonUtilService.getFilterButtons();
    header.filter = false;
    header.minWidth = 120;
    header.filterParams.suppressAndOrCondition = true;
    header.filterParams.filterOptions =
      this.commonUtilService.getCommaSeparatedFilter();
    this.columnDefs.push(header);

    header = this.commonUtilService.getColumnHeader(
      "category_type",
      this.placeHolders['LBL_TBL_CATEGORY']
    );
    header.filterParams = this.commonUtilService.getFilterButtons();
    header.filter = false;
    header.minWidth = 100;
    header.filterParams.suppressAndOrCondition = true;
    header.filterParams.filterOptions =
      this.commonUtilService.getCommaSeparatedFilter();
    this.columnDefs.push(header);

    header = this.commonUtilService.getColumnHeader(
      "status",
      this.placeHolders['LBL_TBL_STATUS']
    );
    header.cellRenderer = SwitchToggleComponent;
    header.filterParams = this.commonUtilService.getFilterButtons();
    header.filter = false;
    header.minWidth = 50;
    header.filterParams.suppressAndOrCondition = true;
    header.filterParams.filterOptions =
      this.commonUtilService.getCommaSeparatedFilter();
    this.columnDefs.push(header);

    header = this.commonUtilService.getColumnHeader(
      "budget",
      this.placeHolders['LBL_TBL_BUDGET']
    );
    // header.pinned = "right";
    header.filter = false;
    header.maxWidth = 90;
    header.filterParams = this.commonUtilService.getFilterButtons();
    header.filterParams.suppressAndOrCondition = true;
    header.filterParams.filterOptions =
      this.commonUtilService.getCommaSeparatedFilter();
    this.columnDefs.push(header);


    header = this.commonUtilService.getColumnHeader(
      "total_spent",
      this.placeHolders['LBL_TBL_ACTUAL_SPENT']
    );
    header.filterParams = this.commonUtilService.getFilterButtons();
    header.filter = false;
    header.maxWidth = 120;
    header.filterParams.suppressAndOrCondition = true;
    header.filterParams.filterOptions =
      this.commonUtilService.getCommaSeparatedFilter();
    this.columnDefs.push(header);

    header = this.commonUtilService.getColumnHeader(
      "spentAlreadyCharged", 'Charged'
      //this.placeHolders['LBL_TBL_ACTUAL_SPENT']
    );
    header.filterParams = this.commonUtilService.getFilterButtons();
    header.filter = false;
    header.maxWidth = 120;
    header.filterParams.suppressAndOrCondition = true;
    header.filterParams.filterOptions =
      this.commonUtilService.getCommaSeparatedFilter();
    this.columnDefs.push(header);

    header = this.commonUtilService.getColumnHeader(
      "",
      this.placeHolders['LBL_TBL_ACTION']
    );
    header.cellRenderer = EditComponent;
    header.cellRendererParams = {
      clicked: (field: any) => {
        // this.campaignService.createEdit(true);
        this.campaignService.setData(field);
        this.router.navigate(["/campaign"]);
      }
    },
      header.filterParams = this.commonUtilService.getFilterButtons();
    header.filter = false;
    header.maxWidth = 74
    header.filterParams.suppressAndOrCondition = true;
    header.filterParams.filterOptions =
      this.commonUtilService.getCommaSeparatedFilter();
    this.columnDefs.push(header);
    if (this.isProd) {
      header = this.commonUtilService.getColumnHeader(
        "",
        this.placeHolders['LBL_TBL_DEALTYPE']
      );
      header.cellRenderer = CreateflashdealComponent;
      header.cellRendererParams = {
        clicked: (field: any) => {
          // this.campaignService.createEdit(true);
          if (!field.flash) {
            this.campaignService.setData(field);
            this.router.navigate(["/campaign"], { queryParams: { createFlash: true } });
          } else {
            field.preventDefault();
          }
        }
      },
        header.filterParams = this.commonUtilService.getFilterButtons();
      header.filter = false;
      header.minWidth = 100
      header.filterParams.suppressAndOrCondition = true;
      header.filterParams.filterOptions =
        this.commonUtilService.getCommaSeparatedFilter();
      this.columnDefs.push(header);
    }

    //FLASH DEAL UNCOMMENT ABOVE TO WORK 

    // header = this.commonUtilService.getColumnHeader(
    //   "",
    //   "Type"
    // );
    // header.cellRenderer = ViewComponent;
    // // header.cellRendererParams = {
    // //   clicked: (field: any) => {
    // //     // this.campaignService.createEdit(true);
    // //     this.campaignService.setData(field);
    // //     this.router.navigate(["/campaign"],{ queryParams: {createFlash: true}});
    // //   }
    // // },
    // header.filterParams = this.commonUtilService.getFilterButtons();
    // header.filter = false;
    // header.maxWidth = 74
    // header.filterParams.suppressAndOrCondition = true;
    // header.filterParams.filterOptions =
    //   this.commonUtilService.getCommaSeparatedFilter();
    // this.columnDefs.push(header);
  }


  createCampaign() {
    // if (this.userData.stripeCustomerId) {
    this.campaignService.setData(null);
    this.router.navigate(["/campaign"]);
    // } else {
    //   if (!this.isCharge){
    //     this.campaignService.setData(null);
    //     this.router.navigate(["/campaign"]);
    //   }else{
    //     this.notifyService.showError("Please set payment method in profile section", "Alert");
    //   }

    // }


    // if (this.availableForDeals) {
    //   this.campaignService.setData(null);
    //   this.router.navigate(["/campaign"]);
    // } else {
    //   if (this.userData.final_payment_flag) {
    //     this.showAlert = true;
    //   } else {
    //     this.campaignService.setData(null);
    //     this.router.navigate(["/campaign"]);
    //   }

    //   // this.notifyService.showError("💡 Add fund to unlock deal creation.", "Alert");
    // }

  }

  closeAlert() {
    this.showAlert = false;
  }

  filterCampaign() {
    this.filterDataForChip = null;
    const modalref = this.dialog.open(FilterCampaignComponent, {
      height: 'auto',
      width: '500px',
      position: {
        top: '12vh',
        left: '30vw'
      },
      autoFocus: false,
      backdropClass: 'custom-dialog-overlay',  // mat-dialog css class
      disableClose: true  // If you click outside the mat-dialog box window, it will not close. 
    });
    this.dashboardService.getCloseEvent().subscribe((res: any) => {
      this.filterDataForChip = [];
      let filterData = res;
      if (filterData !== null && filterData !== undefined) {
        this.dashboardForm.value.categories = [];
        let categoriesArray: any = [];
        if (filterData.category && filterData.category.length !== 0) {
          filterData.category.forEach((item: any) => {
            categoriesArray.push(item);
          })
        }
        this.dashboardForm.value.categories = categoriesArray;
        this.dashboardForm.value.filterStatus = this.status1;
        this.dashboardForm.value.filterbudget = filterData.budget;
        this.dashboardForm.value.filterSpent = filterData.actualSpent;

        this.dashboardForm.get('categories')?.setValue(categoriesArray);
        this.dashboardForm.get('pagination')?.setValue('1');
        this.dashboardForm.get('filterStatus')?.setValue(this.status1);
        this.dashboardForm.get('filterbudget')?.setValue(filterData.budget);
        this.dashboardForm.get('filterSpent')?.setValue(filterData.actualSpent);

        this.getTableData();
        this.filterDataForChip = filterData.chipData;
      }

    });
  }

  addEvent(date: any) {
    this.datePickerInput = date.value;
  }

  setFromDate(event: any) {
    let value = event.target.value;
    let parsedDate = moment(value, "YYYY-MM-DD");
    this.fromDate = parsedDate.format("MM/DD/YYYY");
    this.dashboardForm.value.fromDate = this.fromDate;

  }

  setToDate(event: any) {
    let value = event.target.value;
    let parsedDate = moment(value, "YYYY-MM-DD");
    this.toDate = parsedDate.format("MM/DD/YYYY");
    this.dashboardForm.value.toDate = this.toDate;
  }

  customOkClick() {
    // this.dashboardForm.controls["pagination"].reset(); 
    if (this.toDate && this.fromDate) {


      this.filterDataForChip = null;
      const dateCompare = this.compareDates(this.formatDate(this.fromDate), this.formatDate(this.toDate));
      if (dateCompare === 1) {
        this.notifyService.showError("To Date should be greater than From Date", "Invalid Date");
      } else {
        this.dashboardForm.get('toDate')?.setValue(this.formatDate(this.toDate));
        this.dashboardForm.get('fromDate')?.setValue(this.formatDate(this.fromDate));
        this.dashboardForm.get('pagination')?.setValue('1');
        this.dashboardForm.get('dateFilter')?.setValue(this.dateFilter);
        this.getCampaignTotalData(this.formatDate(this.fromDate), this.formatDate(this.toDate));
      }
    } else {
      this.notifyService.showError("Please select from/to date", "Alert");
    }
  }

  compareDates(fromDateStr: string, toDateStr: string): number {
    const fromDate = new Date(fromDateStr);
    const toDate = new Date(toDateStr);

    // Compare the dates using getTime() method of Date
    if (fromDate.getTime() > toDate.getTime()) {
      return 1; // From date is greater than to date
    } else if (fromDate.getTime() < toDate.getTime()) {
      return -1; // From date is less than to date
    } else {
      return 0; // Dates are equal
    }
  }

  customClick() {
    this.datePickerVisible = true;
    this.dateFilter = '1';
    this.dashboardForm.get('dateFilter')?.setValue(this.dateFilter);
    this.fromDate = null
    this.toDate = null
  }

  displayActivePage(activePageNumber: number) {
    this.activePage = activePageNumber;
    this.dashboardForm.value.pagination = activePageNumber;
    // this.getTableData();
    this.afterPaginationGetTableData();
  }

  afterPaginationGetTableData() {
    this.data = [];

    this.dashboardService.getBrandSpecificDeals(this.dashboardForm.value, this.userData.marketplace_id).subscribe((res: any) => {
      this.recordTotalCount = 0;
      this.campaignTotalData = res?.body?.data;
      // this.createDashboardForm();
      this.recordTotalCount = res?.body?.data?.TOTAL_DEALS;
      if (res && res?.body.data && res?.body.data.DEALS && res?.body.data.DEALS.length !== 0) {
        // this.recordTotalCount = res?.body.data.TOTAL_DEALS ;
        res?.body.data.DEALS.forEach((item: any) => {
          let tableData = item;
          // if (item && item.categories[0]) {
          //   // let data = this.allCategory?.find((i: any) => i.category_id === item.categories[0]);
          //   // tableData.category_type = data?.category_type;
          //   let parsedDate = moment(tableData.created_date, "YYYY-MM-DD");
          //   tableData.created_date = parsedDate.format("DD/MM/YYYY");
          //   this.data.push(tableData);
          // }
          if (item && item.categories) {
            let categoryTypes: string[] = [];
            item.categories.forEach((categoryId: number) => {
              let data = this.allCategory?.find((i: any) => i.category_id === categoryId);
              if (data) {
                categoryTypes.push(data.category_type);
              }
            });
            let parsedDate = moment(tableData.created_date, "YYYY-MM-DD");
            tableData.created_date = parsedDate.format("DD/MM/YYYY");
            tableData.category_type = categoryTypes.join(', ');
            this.data.push(tableData);
          }
        });
        this.createColumnDefs();
      } else {
        //to add mock data here if no data is there in API
        //this.data = this.dashboardData.AllCampaignTestData;
        // to remove when API data comes        
      }
    }, (error) => {

      //this.data = this.dashboardData.AllCampaignTestData;
    });
  }

  search() {
    this.getTableData();
  }

  clearAll() {
    this.filterDataForChip = null;
    // this.dashboardForm.reset();

    // this.dashboardForm.value.categories = [];
    // this.dashboardForm.value.filterStatus = '';
    // this.dashboardForm.value.filterbudget = '';
    // this.dashboardForm.value.filterSpent = '';


    this.dashboardForm.controls["filterStatus"].reset();
    this.dashboardForm.controls["filterbudget"].reset();
    this.dashboardForm.controls["filterSpent"].reset();
    this.dashboardForm.controls["categories"].reset();

    this.dashboardForm.get('filterStatus')?.setValue('');
    this.dashboardForm.get('filterbudget')?.setValue('');
    this.dashboardForm.get('filterSpent')?.setValue('');
    this.dashboardForm.get('categories')?.setValue('');
    this.dashboardForm.value.categories = [];
    this.dashboardForm.value.filterStatus = '';
    this.dashboardForm.value.filterbudget = '';
    this.dashboardForm.value.filterSpent = '';
    this.dashboardForm.get('pagination')?.setValue('1');
    this.last15DaysData();
  }

  getDynamicClass() {
    return this.placeholders['locale'] === 'en' ? 'classEn' : 'classFr';
  }

  createrecordtext() {
    return this.placeholders['locale'] === 'en' ? 'createrecordtextEn' : 'createrecordtextFr';
  }

  reload() {
    window.location.reload();
  }

  onEdit(row: any) {
    this.campaignService.setData(row);
    this.router.navigate(['/campaign']);
  }



  onCreateFlash(row: any) {
    // if (!row.flash) {
    const selectedData = {
      ...row,
      total_spent: null,
      authorizedAmount: null,
      amountAuthorizedDate: null,
      amountCapturedDate: null,
      budget: null,
      status: 'D',
      available_from: null,
      available_to: null,
      capturedAmount: null,
      paymentDone: null,
      product_id: null,
      uuid: null
    };
    this.campaignService.setData(selectedData);
    this.router.navigate(['/campaign'], { queryParams: { createFlash: selectedData.flash } });
    // }
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'A': return 'active-chip';
      case 'P': return 'pending-chip';
      case 'E': return 'expired-chip';
      case 'I': return 'inactive-chip';
      case 'D': return 'draft-chip';
      case 'U': return 'upcoming-chip';
      case 'S': return 'paused-chip';
      case 'R': return 'rejected-chip';
      case 'N': return 'new-chip';
      case 'C': return 'completed-chip';
      case 'T': return 'expired-chip';
      default: return '';
    }
  }

  getStatusLabel(status: string): string {
    switch (status) {
      case 'A': return this.reportPlaceHolders['LBL_ACTIVE'];
      case 'P': return this.reportPlaceHolders['LBL_PENDING'];
      case 'E': return this.reportPlaceHolders['LBL_EXPIRED'];
      case 'I': return this.reportPlaceHolders['LBL_INACTIVE'];
      case 'D': return this.reportPlaceHolders['LBL_DRAFT'];
      case 'U': return this.reportPlaceHolders['LBL_UPCOMING'];
      case 'S': return this.reportPlaceHolders['LBL_PAUSED'];
      case 'R': return this.reportPlaceHolders['LBL_REJECTED'];
      case 'N': return this.reportPlaceHolders['LBL_NEW'];
      case 'C': return this.reportPlaceHolders['LBL_COMPLETED'];
      case 'T': return 'Terminated';
      default: return 'Unknown';
    }
  }

  getFullImageUrl(imagePath: string): string {
    return `${environment.assetsUrl}/assets/${imagePath}`;
  }

  selectedRow: any = null;
  showPopup = false;

  onView(row: any) {
    this.selectedRow = row;
    this.showPopup = true;
  }

  closePopup() {
    this.showPopup = false;
    this.selectedRow = null;
  }

  shouldShowEditIcon(status: string, excludedStatuses: string[] = ['E', 'C','T']): boolean {
    return !excludedStatuses.includes(status);
  }
  shouldShowViewIcon(status: string, excludedStatuses: string[] = ['']): boolean {
    return !excludedStatuses.includes(status);
  }

  shouldShowReceiptIcon(status: string, excludedStatuses: string[] = ['D', 'S', 'A', 'R', 'P']): boolean {
    return !excludedStatuses.includes(status);
  }




  selectedRange: string = 'custom'; // default
  budget1: string = '';
  charged1: string = '';
  fromDate1: NgbDateStruct | null = null;
  toDate1: NgbDateStruct | null = null;
  status1: string = ''
  category: any = []

  onRangeChange() {
    if (this.selectedRange !== 'custom') {
      this.fromDate1 = null;
      this.toDate1 = null;
      // Load data for predefined range
    }

    switch (this.selectedRange) {
      case '7':
        this.lastWeekData()
        break;
      case '15':
        this.last15DaysData()
        break;
      case '30':
        this.lastMonthData()
        break;
      case '90':
        this.last3MonthData()
        break;
    }


  }

  showfilterChip: boolean = false
  showFilter: boolean = false
  categoryArray: any = [];
  filterDetails() {
    debugger
    this.dashboardForm.value.categories = [];
    let categoriesArray: any = [];
    if (this.categoryArray && this.categoryArray.length !== 0) {
      this.categoryArray.forEach((item: any) => {
        categoriesArray.push(item);
        this.selectedCategory = this.category.map((cat: any) => cat.category_type).join(', ');
      })
    }

    // this.dashboardForm.value.categories = categoriesArray;
    this.dashboardForm.value.filterStatus = this.status1;
    this.dashboardForm.value.filterbudget = this.budget1;
    this.dashboardForm.value.filterSpent = this.charged1;
    this.dashboardForm.value.categories = categoriesArray;

    // this.dashboardForm.get('categories')?.setValue(categoriesArray);
    // this.dashboardForm.get('pagination')?.setValue('1');
    this.dashboardForm.get('filterStatus')?.setValue(this.status1);
    this.dashboardForm.get('filterbudget')?.setValue(this.budget1);
    this.dashboardForm.get('filterSpent')?.setValue(this.charged1);
    this.dashboardForm.get('categories')?.setValue(categoriesArray);
    this.selectedStatus = this.status1;
    this.selectedBudget = this.budget1;
    this.selectedCharged = this.charged1;
    if (this.selectedRange === 'custom') {
      this.showfilterChip = false;
      this.fromDate = this.fromDate1
      this.toDate = this.toDate1
      this.customOkClick()
    } else {
      this.getTableData();
    }

  }

  formatDate(dateObj?: { year: number; month: number; day: number }): string {
    debugger
    if (!dateObj) return '';
    const { year, month, day } = dateObj;
    return `${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}/${year}`;
  }

  selectedStatus: string | null = '';
  selectedCategory: string | null = '';
  // selectedRange: string | null = 'custom';
  selectedBudget: string | null = '';
  selectedCharged: string | null = '';

  clearFilter(type: string) {
    switch (type) {
      case 'status':
        this.selectedStatus = null;
        this.dashboardForm.controls["filterStatus"].reset();
        this.dashboardForm.get('filterStatus')?.setValue('');
        this.dashboardForm.value.filterStatus = '';
        this.status1 = ''
        this.filterDetails()
        break;
      case 'category':
        this.selectedCategory = null;
        this.categoryArray = []
        this.category = []
        this.dashboardForm.controls["categories"].reset();
        this.dashboardForm.get('categories')?.setValue('');
        this.dashboardForm.value.categories = [];
        this.filterDetails()
        break;
      case 'range':
        this.selectedRange = '15';
        this.fromDate = null;
        this.toDate = null;
        this.dashboardForm.controls["fromDate"].reset();
        this.dashboardForm.get('fromDate')?.setValue(null);
        this.dashboardForm.controls["toDate"].reset();
        this.dashboardForm.get('toDate')?.setValue(null);
        this.showfilterChip = false;
        this.last15DaysData()
        break;
      case 'budget':
        this.selectedBudget = null;
        this.dashboardForm.controls["filterbudget"].reset();
        this.dashboardForm.get('filterbudget')?.setValue('');
        this.dashboardForm.value.filterbudget = '';
        this.budget1 = ''
        this.filterDetails()
        break;
      case 'charge':
        this.selectedCharged = null;
        this.dashboardForm.controls["filterSpent"].reset();
        this.dashboardForm.get('filterSpent')?.setValue('');
        this.dashboardForm.value.filterSpent = '';
        this.charged1 = ''
        this.filterDetails()
        break;
    }

  }




  budgetOptions: { [key: string]: string } = {
    '0': '$0 - $1000',
    '1': '$1001 - $9999',
    '2': ' Above $9999',
    '': 'All'
  };


  getBudgetLabel(value: string): string {
    return this.budgetOptions[value] || value;
  }

  selectedCategories: any[] = [];

  onCategoryChange(event: any) {
    // You can extract selected category names or IDs here
    this.categoryArray = this.category.map((cat: any) => cat.category_id);

  }

  paymentTotalDataReport: any
  dealReceiptDetails: any;
  succeededPayments: any;
  receiptDownload(row: any) {
    debugger
    this.dealReceiptDetails = row
    let payload = {
      dealId: row.product_id,
      from: '07/12/2025',
      to: '08/21/2025'
    }

    const fromDate = this.formatDate(this.fromDate)
    const toDate = this.formatDate(this.toDate)
    this.dashboardService.paymentReceiptDealAllData(this.userData.marketplace_id, payload.from, payload.to, payload.dealId).subscribe((res: any) => {
      this.paymentTotalDataReport = res.body?.data?.content ?? []
      this.succeededPayments = this.paymentTotalDataReport.filter((p: any) => p.status === 'succeeded');
      this.generateReceipt(this.succeededPayments, this.userData, this.dealReceiptDetails)
    });

  }




  //   generateReceipt(data: any[], merchant: any,dealDetails:any) {
  // debugger
  //     dealDetails 
  //     const doc = new jsPDF();

  //     // Load logo from assets
  //     const logo = this.receiptlogo;

  //     fetch(logo)
  //       .then(res => res.blob())
  //       .then(blob => {
  //         const reader = new FileReader();
  //         reader.onload = () => {
  //           const base64Logo = reader.result as string;

  //           // Add Logo top-left
  //           doc.addImage(base64Logo, 'PNG', 15, 10, 40, 20);

  //           // Title
  //           doc.setFontSize(16);
  //           doc.setTextColor(41, 128, 185); // blue shade
  //           doc.text('Payment Receipt', 105, 25, { align: 'center' });

  //           // Green line separator
  //           doc.setDrawColor(0, 128, 0);
  //           doc.setLineWidth(0.7);
  //           doc.line(15, 35, 195, 35);

  //           // Merchant Info Section
  //           doc.setFontSize(11);
  //           doc.setTextColor(0);
  //           autoTable(doc, {
  //             startY: 40,
  //             theme: 'grid',
  //             head: [['TO', 'FROM', 'Date', 'Receipt Id']],
  //             body: [
  //               [
  //                 `${merchant.marketplace_name},\n${merchant.addressLine1}\nPhone: ${merchant.business_contact_number}\nEmail: ${merchant.uuid}`,
  //                 `MapMyID Pvt.LTD\nAddress:\nGST Number:\nPAN Number:`,
  //                 new Date().toLocaleDateString(),
  //                 data[0]?.receiptId || ''
  //               ]
  //             ],
  //             styles: { halign: 'left', cellPadding: 4 },
  //             headStyles: { fillColor: [199, 234, 199], textColor: 0 },
  //             bodyStyles: { fillColor: [235, 247, 235] },
  //           });

  //           // Green line separator
  //           doc.setDrawColor(0, 128, 0);
  //           doc.line(15, (doc as any).lastAutoTable.finalY + 5, 195, (doc as any).lastAutoTable.finalY + 5);

  //           // Payment Details Table
  //           const tableData = data.map(item => [
  //             `${item.description} – ${item.deal_uuid}`,
  //             new Date(item.created_date).toLocaleDateString(),
  //             `${item.display_brand?.toUpperCase() || ''} ****${item.last4}`,
  //             `$${item.amount}`
  //           ]);

  //           autoTable(doc, {
  //             startY: (doc as any).lastAutoTable.finalY + 10,
  //             theme: 'grid',
  //             head: [['Receipt ID', 'Date for payment', 'Payment Method', 'Amount']],
  //             body: tableData,
  //             styles: {
  //               halign: 'center',
  //               valign: 'middle',
  //               fontSize: 10,
  //               lineColor: [0, 0, 0],
  //               lineWidth: 0.1
  //             },
  //             headStyles: { fillColor: [199, 234, 199], textColor: 0, fontStyle: 'bold' },
  //             bodyStyles: { fillColor: [240, 248, 240] },
  //           });

  //           // Totals Section
  //           const total = data.reduce((sum, x) => sum + x.amount, 0);

  //           autoTable(doc, {
  //             startY: (doc as any).lastAutoTable.finalY + 5,
  //             theme: 'grid',
  //             body: [
  //               ['SUBTOTAL', `$${total}`],
  //               ['VAT/GST', '$0'],
  //               ['TOTAL', `$${total}`]
  //             ],
  //             styles: { halign: 'right', fontStyle: 'bold' },
  //             bodyStyles: { fillColor: [235, 247, 235] },
  //           });

  //           // Save
  //           doc.save(`receipt_${new Date().getTime()}.pdf`);
  //         };
  //         reader.readAsDataURL(blob);
  //       });
  //   }



  // generateReceipt(data: any[], merchant: any, dealDetails: any) {
  //   const doc = new jsPDF();

  //   const logo = this.receiptlogo; // path from assets or base64

  //   fetch(logo)
  //     .then(res => res.blob())
  //     .then(blob => {
  //       const reader = new FileReader();
  //       reader.onload = () => {
  //         const base64Logo = reader.result as string;

  //         // ✅ Add Logo
  //         doc.addImage(base64Logo, 'PNG', 15, 10, 40, 20);

  //         // Title
  //         doc.setFontSize(16);
  //         doc.setTextColor(41, 128, 185);
  //         doc.text('Payment Receipt', 105, 25, { align: 'center' });

  //         // Green line
  //         doc.setDrawColor(0, 128, 0);
  //         doc.setLineWidth(0.7);
  //         doc.line(15, 35, 195, 35);

  //         // ✅ Merchant Info
  //         autoTable(doc, {
  //           startY: 40,
  //           theme: 'grid',
  //           head: [['TO', 'FROM', 'Date', 'Receipt Id']],
  //           body: [
  //             [
  //               `${merchant.marketplace_name},\n${merchant.addressLine1}\nPhone: ${merchant.business_contact_number}\nEmail: ${merchant.uuid}`,
  //               `MapMyID Pvt.LTD\nAddress:\nGST Number:\nPAN Number:`,
  //               new Date().toLocaleDateString(),
  //               data[0]?.receiptId || ''
  //             ]
  //           ],
  //           styles: { halign: 'left', cellPadding: 4 },
  //           headStyles: { fillColor: [199, 234, 199], textColor: 0 },
  //           bodyStyles: { fillColor: [235, 247, 235] },
  //         });

  //         let currentY = (doc as any).lastAutoTable.finalY + 10;

  //         // ✅ Add Deal Info Section
  //         if (dealDetails) {
  //           // Product Image
  //           if (dealDetails.product_image) {
  //             const productImg = `https://assets-dev.ship2myid.com/assets/${dealDetails.product_image}`; // adjust CDN path if needed
  //             fetch(productImg)
  //               .then(res => res.blob())
  //               .then(imgBlob => {
  //                 const imgReader = new FileReader();
  //                 imgReader.onload = () => {
  //                   const base64ProductImg = imgReader.result as string;
  //                   doc.addImage(base64ProductImg, 'WEBP', 20, currentY, 30, 30);

  //                   // Product details text
  //                   doc.setFontSize(11);
  //                   doc.setTextColor(0);
  //                   doc.text(`Deal: ${dealDetails.product_name}`, 60, currentY + 5);
  //                   doc.text(`UUID: ${dealDetails.uuid}`, 60, currentY + 12);
  //                   doc.text(`From: ${new Date(dealDetails.available_from).toLocaleDateString()}`, 60, currentY + 19);
  //                   doc.text(`To: ${new Date(dealDetails.available_to).toLocaleDateString()}`, 60, currentY + 26);

  //                   // Green separator
  //                   doc.setDrawColor(0, 128, 0);
  //                   doc.line(15, currentY + 40, 195, currentY + 40);

  //                   // ✅ Payment Table
  //                   this.addPaymentTables(doc, data, currentY + 45);
  //                 };
  //                 imgReader.readAsDataURL(imgBlob);
  //               });
  //           } else {
  //             // if no image → just text
  //             doc.text(`Deal: ${dealDetails.product_name}`, 20, currentY);
  //             doc.text(`UUID: ${dealDetails.uuid}`, 20, currentY + 7);
  //             doc.text(`From: ${new Date(dealDetails.available_from).toLocaleDateString()}`, 20, currentY + 14);
  //             doc.text(`To: ${new Date(dealDetails.available_to).toLocaleDateString()}`, 20, currentY + 21);

  //             doc.setDrawColor(0, 128, 0);
  //             doc.line(15, currentY + 30, 195, currentY + 30);

  //             this.addPaymentTables(doc, data, currentY + 35);
  //           }
  //         }
  //       };
  //       reader.readAsDataURL(blob);
  //     });
  // }

  // // ✅ Extracted function to add payment + totals tables
  // private addPaymentTables(doc: any, data: any[], startY: number) {
  //   const tableData = data.map(item => [
  //     `${item.description} – ${item.deal_uuid}`,
  //     new Date(item.created_date).toLocaleDateString(),
  //     `${item.display_brand?.toUpperCase() || ''} ****${item.last4}`,
  //     `$${item.amount}`
  //   ]);

  //   autoTable(doc, {
  //     startY,
  //     theme: 'grid',
  //     head: [['Receipt ID', 'Date for payment', 'Payment Method', 'Amount']],
  //     body: tableData,
  //     styles: { halign: 'center', valign: 'middle', fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
  //     headStyles: { fillColor: [199, 234, 199], textColor: 0, fontStyle: 'bold' },
  //     bodyStyles: { fillColor: [240, 248, 240] },
  //   });

  //   const total = data.reduce((sum, x) => sum + x.amount, 0);

  //   autoTable(doc, {
  //     startY: (doc as any).lastAutoTable.finalY + 5,
  //     theme: 'grid',
  //     body: [
  //       ['SUBTOTAL', `$${total}`],
  //       ['VAT/GST', '$0'],
  //       ['TOTAL', `$${total}`]
  //     ],
  //     styles: { halign: 'right', fontStyle: 'bold' },
  //     bodyStyles: { fillColor: [235, 247, 235] },
  //     columnStyles: {
  //       0: { halign: 'right', cellWidth: 130 },
  //       1: { halign: 'right', cellWidth: 40 }
  //     }
  //   });

  //   doc.save(`receipt_${new Date().getTime()}.pdf`);
  // }




  generateReceipt1(data: any[], merchant: any, dealDetails: any) {
    const doc = new jsPDF();
    const logo = this.receiptlogo;

    fetch(logo)
      .then(res => res.blob())
      .then(blob => {
        const reader = new FileReader();
        reader.onload = () => {
          const base64Logo = reader.result as string;

          // ✅ Logo
          doc.addImage(base64Logo, 'PNG', 15, 10, 40, 20);

          // Title
          doc.setFontSize(16);
          doc.setTextColor(41, 128, 185);
          doc.text(this.placeHolders['LBL_PAYMENT_RECEIPT'], 105, 25, { align: 'center' });

          // Green line
          doc.setDrawColor(0, 128, 0);
          doc.setLineWidth(0.7);
          doc.line(15, 35, 195, 35);

          // ✅ Merchant Info
          autoTable(doc, {
            startY: 40,
            theme: 'grid',
            head: [[this.placeHolders['LBL_TO'], this.placeHolders['LBL_FROM'], this.placeHolders['LBL_DATE'], this.placeHolders['LBL_RECEIPT_ID']]],
            body: [
              [
                `${merchant.marketplace_name},\n${merchant.addressLine1}\nPhone: ${merchant.business_contact_number}\nEmail: ${merchant.uuid}`,
                `MapMyID Pvt.LTD\nAddress:\nGST Number:\nPAN Number:`,
                new Date().toLocaleDateString(),
                data[0]?.receiptId || ''
              ]
            ],
            styles: { halign: 'left', cellPadding: 4 },
            headStyles: { fillColor: [199, 234, 199], textColor: 0 },
            bodyStyles: { fillColor: [235, 247, 235] },
          });

          let currentY = (doc as any).lastAutoTable.finalY + 10;

          // ✅ Deal Info Section
          if (dealDetails) {
            const boxX = 15;
            const boxY = currentY;
            const boxWidth = 180;
            const boxHeight = 40;

            // Light grey rounded rectangle
            doc.setFillColor(245, 245, 245);
            doc.roundedRect(boxX, boxY, boxWidth, boxHeight, 3, 3, 'F');

            // Product Image
            if (dealDetails.product_image) {
              const productImg = `https://assets-dev.ship2myid.com/assets/${dealDetails.product_image}`;
              fetch(productImg)
                .then(res => res.blob())
                .then(imgBlob => {
                  const imgReader = new FileReader();
                  imgReader.onload = () => {
                    const base64ProductImg = imgReader.result as string;
                    doc.addImage(base64ProductImg, 'WEBP', boxX + 5, boxY + 5, 25, 25);

                    // Product Details
                    doc.setFontSize(11);
                    doc.setTextColor(0);
                    doc.text(`Deal: ${dealDetails.product_name}`, boxX + 35, boxY + 10);
                    doc.text(`UUID: ${dealDetails.uuid}`, boxX + 35, boxY + 16);
                    doc.text(`From: ${new Date(dealDetails.available_from).toLocaleDateString()}`, boxX + 35, boxY + 22);
                    doc.text(`To: ${new Date(dealDetails.available_to).toLocaleDateString()}`, boxX + 35, boxY + 28);

                    // Separator line
                    doc.setDrawColor(0, 128, 0);
                    doc.line(15, boxY + boxHeight + 5, 195, boxY + boxHeight + 5);

                    // Continue with payments table
                    this.addPaymentTables(doc, data, boxY + boxHeight + 10);
                  };
                  imgReader.readAsDataURL(imgBlob);
                });
            } else {
              // If no image → text only
              doc.setFontSize(11);
              doc.setTextColor(0);
              doc.text(`Deal: ${dealDetails.product_name}`, boxX + 10, boxY + 12);
              doc.text(`UUID: ${dealDetails.uuid}`, boxX + 10, boxY + 18);
              doc.text(`From: ${new Date(dealDetails.available_from).toLocaleDateString()}`, boxX + 10, boxY + 24);
              doc.text(`To: ${new Date(dealDetails.available_to).toLocaleDateString()}`, boxX + 10, boxY + 30);

              doc.setDrawColor(0, 128, 0);
              doc.line(15, boxY + boxHeight + 5, 195, boxY + boxHeight + 5);

              this.addPaymentTables(doc, data, boxY + boxHeight + 10);
            }
          }
        };
        reader.readAsDataURL(blob);
      });
  }

  // ✅ Payments + Totals
  private addPaymentTables1(doc: any, data: any[], startY: number) {
    const tableData = data.map(item => [
      `${item.description} – ${item.deal_uuid}`,
      new Date(item.created_date).toLocaleDateString(),
      `${item.display_brand?.toUpperCase() || ''} ****${item.last4}`,
      `$${item.amount}`
    ]);

    autoTable(doc, {
      startY,
      theme: 'grid',
      head: [['Receipt ID', this.placeHolders['LBL_DATE_FOR_PAYMENT'], this.placeHolders['LBL_PAYMENT_METHOD'], this.placeHolders['LBL_AMOUNT']]],
      body: tableData,
      styles: { halign: 'center', valign: 'middle', fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
      headStyles: { fillColor: [199, 234, 199], textColor: 0, fontStyle: 'bold' },
      bodyStyles: { fillColor: [240, 248, 240] },
    });

    const total = data.reduce((sum, x) => sum + x.amount, 0);

    autoTable(doc, {
      startY: (doc as any).lastAutoTable.finalY + 5,
      theme: 'grid',
      body: [
        ['SUBTOTAL', `$${total}`],
        ['VAT/GST', '$0'],
        ['TOTAL', `$${total}`]
      ],
      styles: { halign: 'right', fontStyle: 'bold' },
      bodyStyles: { fillColor: [235, 247, 235] },
    });

    // ✅ Footer Section
    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text(
      this.placeHolders['LBL_RECEIPT_FOOTER'],
      105,
      pageHeight - 20,
      { align: 'center', maxWidth: 180 }
    );
    doc.text(
      this.placeHolders['LBL_COMPUTER_GENERATED'],
      105,
      pageHeight - 12,
      { align: 'center' }
    );

    doc.save(`receipt_${new Date().getTime()}.pdf`);
  }

  generateReceipt(data: any[], merchant: any, dealDetails: any) {
    debugger
    const doc = new jsPDF();
    const logo = this.receiptlogo;

    // Helper to render header + merchant info
    const renderHeaderAndMerchant = (doc: any, base64Logo?: string) => {
      // ✅ Logo
      if (base64Logo) {
        try {
          doc.addImage(base64Logo, 'PNG', 15, 10, 40, 20);
        } catch (err) {
          console.warn('⚠️ Logo skipped due to error:', err);
        }
      }

      // Title
      doc.setFontSize(16);
      doc.setTextColor(41, 128, 185);
      doc.text(this.placeHolders['LBL_PAYMENT_RECEIPT'], 105, 25, { align: 'center' });

      // Green line
      doc.setDrawColor(0, 128, 0);
      doc.setLineWidth(0.7);
      doc.line(15, 35, 195, 35);

      // ✅ Merchant Info
      autoTable(doc, {
        startY: 40,
        theme: 'grid',
        head: [[
          this.placeHolders['LBL_TO'],
          this.placeHolders['LBL_FROM'],
          this.placeHolders['LBL_DATE'],
          this.placeHolders['LBL_RECEIPT_ID']
        ]],
        body: [[
          `${merchant.marketplace_name},\n${merchant.addressLine1}\nPhone: ${merchant.business_contact_number}\nEmail: ${merchant.uuid}`,
          `MapMyID Pvt.LTD\nAddress:\nGST Number:\nPAN Number:`,
          new Date().toLocaleDateString(),
          data[0]?.receiptId || ''
        ]],
        styles: { halign: 'left', cellPadding: 4 },
        headStyles: { fillColor: [199, 234, 199], textColor: 0 },
        bodyStyles: { fillColor: [235, 247, 235] },
      });

      return (doc as any).lastAutoTable.finalY + 10;
    };

    // Helper for product details box
    const renderDealSection = (doc: any, dealDetails: any, data: any[], startY: number, base64ProductImg?: string) => {
      const boxX = 15;
      const boxY = startY;
      const boxWidth = 180;
      const boxHeight = 40;

      // Light grey rounded rectangle
      doc.setFillColor(245, 245, 245);
      doc.roundedRect(boxX, boxY, boxWidth, boxHeight, 3, 3, 'F');

      if (base64ProductImg) {
        try {
          doc.addImage(base64ProductImg, 'WEBP', boxX + 5, boxY + 5, 25, 25);
        } catch (err) {
          console.warn('⚠️ Product image skipped due to error:', err);
        }
      }

      // Product Details
      const textX = base64ProductImg ? boxX + 35 : boxX + 10;
      doc.setFontSize(11);
      doc.setTextColor(0);
      doc.text(`Deal: ${dealDetails.product_name}`, textX, boxY + 10);
      doc.text(`UUID: ${dealDetails.uuid}`, textX, boxY + 16);
      doc.text(`From: ${new Date(dealDetails.available_from).toLocaleDateString()}`, textX, boxY + 22);
      doc.text(`To: ${new Date(dealDetails.available_to).toLocaleDateString()}`, textX, boxY + 28);

      // Separator line
      doc.setDrawColor(0, 128, 0);
      doc.line(15, boxY + boxHeight + 5, 195, boxY + boxHeight + 5);

      // Payments
      this.addPaymentTables(doc, data, boxY + boxHeight + 10);
    };

    // Try to load logo
    fetch(logo)
      .then(res => res.blob())
      .then(blob => {
        const reader = new FileReader();
        reader.onload = () => {
          const base64Logo = reader.result as string;
          const currentY = renderHeaderAndMerchant(doc, base64Logo);

          if (dealDetails?.product_image) {
            const productImg = `https://assets-dev.ship2myid.com/assets/${dealDetails.product_image}`;
            fetch(productImg)
              .then(res => res.blob())
              .then(imgBlob => {
                const imgReader = new FileReader();
                imgReader.onload = () => {
                  const base64ProductImg = imgReader.result as string;
                  renderDealSection(doc, dealDetails, data, currentY, base64ProductImg);
                };
                imgReader.readAsDataURL(imgBlob);
              })
              .catch(err => {
                console.warn('⚠️ Product image fetch failed, skipping:', err);
                renderDealSection(doc, dealDetails, data, currentY);
              });
          } else {
            renderDealSection(doc, dealDetails, data, currentY);
          }
        };
        reader.readAsDataURL(blob);
      })
      .catch(err => {
        console.warn('⚠️ Logo fetch failed, skipping:', err);
        const currentY = renderHeaderAndMerchant(doc);
        if (dealDetails) {
          renderDealSection(doc, dealDetails, data, currentY);
        }
      });
  }

  // ✅ Payments + Totals
  private addPaymentTables(doc: any, data: any[], startY: number) {
    debugger
    const tableData = data.map(item => [
      `${item.description} – ${item.deal_uuid}`,
      new Date(item.created_date).toLocaleDateString(),
      `${item.display_brand?.toUpperCase() || ''} ****${item.last4}`,
      `$${item.amount}`
    ]);

    autoTable(doc, {
      startY,
      theme: 'grid',
      head: [[
        'Receipt ID',
        this.placeHolders['LBL_DATE_FOR_PAYMENT'],
        this.placeHolders['LBL_PAYMENT_METHOD'],
        this.placeHolders['LBL_AMOUNT']
      ]],
      body: tableData,
      styles: { halign: 'center', valign: 'middle', fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
      headStyles: { fillColor: [199, 234, 199], textColor: 0, fontStyle: 'bold' },
      bodyStyles: { fillColor: [240, 248, 240] },
    });
    const total = data.reduce((sum, x) => sum + x.amount, 0);

    autoTable(doc, {
      startY: (doc as any).lastAutoTable.finalY + 5,
      theme: 'grid',
      body: [
        ['SUBTOTAL', `$${total}`],
        ['VAT/GST', '$0'],
        ['TOTAL', `$${total}`]
      ],
      styles: { halign: 'right', fontStyle: 'bold' },
      bodyStyles: { fillColor: [235, 247, 235] },
    });

    // ✅ Footer Section
    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text(this.placeHolders['LBL_RECEIPT_FOOTER'], 105, pageHeight - 20, { align: 'center', maxWidth: 180 });
    doc.text(this.placeHolders['LBL_COMPUTER_GENERATED'], 105, pageHeight - 12, { align: 'center' });

    doc.save(`receipt_${new Date().getTime()}.pdf`);
  }



  // Stripe Implementation

  stripe: any;
  card: any;

  customerId: string = '';
  paymentMethodId: string = '';
  // amount: number = 0;
  // currency: string = 'USD';
  customerName: string = '';
  customerEmail: string = '';
  customerCountry: string = '';
  customerState: string = '';
  customerCity: string = '';
  customerPincode: any = '';
  customerPhone: number = 0;
  errorMessage: string = '';
  customerLine1: string = '';
  customerLine2: string = '';
  selectedCountryCode: string = '';

  // paymentMethod: any;
  paymentCustID: any;

  //pk_live_51QG4UlLzjH9c5pL5pAGleI2smbVWdjteuB0pzbZyME44uoLBASAhIYiPjJI7KApI11bn55CnrpE9lvKBlVXvta53005KN9L92y
  initializeStripe1() {
    debugger
    // let fullName = this.data.firstName.concat(" " + this.data.lastName);
    // let Email = this.data.email_id
    // this.customerEmail = Email
    // this.customerName = fullName
    // this.customerCountry = this.merchantCountry
    this.stripe = Stripe('pk_test_51QG4UlLzjH9c5pL5IrWTC45XXgzRjHxUumnnDH0CrZXyv8Ei51kW13f4aFZhU380viDIb7tkQEft59lgPEmv9DIj00XuCD4LyT');
    const options = {
      // mode: 'setup', // Change to 'payment' for actual payments
      // currency: 'usd',
      appearance: {}, // Customize as needed
    };
    this.card = this.stripe.elements().create('card', {
      style: {
        base: {
          fontSize: "16px",
          color: "#32325d",
          fontFamily: "Arial, sans-serif",
          "::placeholder": {
            color: "#aab7c4",
          },
        },
      },
      hidePostalCode: true, // Set to true if you don’t want ZIP code
      placeholder: "1234 5678 9012 3456", // Set default placeholder for card
      // disableLink :true
    });
    const elements = this.stripe.elements(options);
    // this.card = elements.create('card');

    // Wait for the component to render completely
    setTimeout(() => {
      this.card.mount(this.cardElement.nativeElement);
    });
  }
  modalRef!: NgbModalRef;
  availableAmount = 0;
  spentAmount = 0;
  // amount = 0;
  showModal = false; // 
  // paymentMethod = '';


  openAddFunds() {
    this.closeAlert();
    this.showModal = true;
    // Wait until Angular renders modal DOM
    setTimeout(() => this.initializeStripe(), 0);
  }

  closeAddFunds() {
    this.showModal = false;
    if (this.card) {
      this.card.destroy(); // clean up Stripe element
    }
  }

  initializeStripe() {
    this.customerEmail = this.userEmail
    this.customerName = this.dashName
    if (!this.stripe) {
      this.stripe = Stripe('pk_test_51QG4UlLzjH9c5pL5IrWTC45XXgzRjHxUumnnDH0CrZXyv8Ei51kW13f4aFZhU380viDIb7tkQEft59lgPEmv9DIj00XuCD4LyT');
    }

    const elements = this.stripe.elements();
    this.card = elements.create('card', {
      style: {
        base: {
          fontSize: '16px',
          color: '#32325d',
          fontFamily: 'Arial, sans-serif',
          '::placeholder': { color: '#aab7c4' },
        },
      },
      hidePostalCode: true,
    });

    this.card.mount(this.cardElement.nativeElement);
  }

  // async addFunds() {
  //   try {
  //     // 1️⃣ Create Stripe PaymentMethod
  //     const { paymentMethod, error } = await this.stripe.createPaymentMethod({
  //       type: 'card',
  //       card: this.card,
  //     });

  //     if (error) {
  //       console.error('Stripe error:', error);
  //       alert(error.message);
  //       return;
  //     }

  //     console.log('Payment Method:', paymentMethod.id);

  //     // 2️⃣ Check if wallet exists (based on your data)
  //     const walletExists = !!this.availableAmount || !!this.spentAmount;
  //     // OR call a GET wallet API here if backend provides

  //     // 3️⃣ If wallet doesn’t exist, create it first
  //     if (!walletExists) {
  //       const addWalletUrl = `${this.baseUrl}/orchestration-service/admin/brand/wallet/add?userId=${this.userId}`;
  //       await this.http.post(addWalletUrl, {
  //         brandId: this.brandId,
  //         currency: 'usd'
  //       }, { headers: this.getHeaders() }).toPromise();

  //       console.log('Wallet created successfully!');
  //     }

  //     // 4️⃣ Always call Topup
  //     const topupUrl = `${environment.authUrl}/orchestration-service/admin/brand/wallet/topup?userId=${this.userId}`;
  //     const topupRes: any = await this.http.post(topupUrl, {
  //       amount: this.amount,
  //       currency: 'usd',
  //       brandId: this.brandId,
  //       paymentMethodId: paymentMethod.id
  //     }, { headers: this.getHeaders() }).toPromise();

  //     console.log('Topup Success:', topupRes);

  //     // 5️⃣ Update UI immediately
  //     this.availableAmount = (this.availableAmount || 0) + this.amount;
  //     alert('Funds added successfully!');
  //     this.closeAddFunds();

  //   } catch (err) {
  //     console.error('Error adding funds:', err);
  //     alert('Something went wrong while adding funds.');
  //   }
  // }

  addFunds() {
    debugger
    // 1️⃣ Create Stripe Payment Method
    this.stripe.createPaymentMethod({ type: 'card', card: this.card })
      .then(({ paymentMethod, error }: { paymentMethod: any; error: any }) => {
        if (error) {
          console.error('Stripe error:', error);
          alert(error.message);
          return;
        }

        console.log('Payment Method ID:', paymentMethod.id);

        // 2️⃣ Check wallet existence
        this.dashboardService.walletExists(this.personID).pipe(
          switchMap(walletRes => {
            const walletExists = walletRes && walletRes.data;

            // 3️⃣ If wallet does NOT exist, create it
            if (!walletExists) {
              return this.dashboardService.addWallet(this.personID, this.userData.marketplace_id).pipe(
                switchMap(() => this.dashboardService.topUpWallet(
                  this.personID,
                  this.userData.marketplace_id,
                  this.amount,
                  paymentMethod.id
                ))
              );
            }

            // 4️⃣ If wallet exists, just topup
            return this.dashboardService.topUpWallet(
              this.personID,
              this.userData.marketplace_id,
              this.amount,
              paymentMethod.id
            );
          }),
          catchError(err => {
            console.error('Error adding funds:', err);
            // alert('Something went wrong while adding funds.');
            this.notifyService.showError("Something went wrong while adding funds.", "Alert");
            return of(null); // handle error and continue
          })
        ).subscribe(topupRes => {
          if (topupRes) {
            debugger
            console.log('Topup Success:', topupRes);
            this.availableAmount = (this.availableAmount || 0) + this.amount;
            if (topupRes.status === 'ERROR') {
              this.notifyService.showError(topupRes.message, "Error");
            } else {
              this.notifyService.showSuccess("Funds added successfully!", "Success");
            }

            // alert('Funds added successfully!');
            // ✅ Refresh wallet AFTER successful top-up
            // Delay 2 seconds before refreshing
            setTimeout(() => {
              this.loadWallet()
            }, 2000);
            this.closeAddFunds();
          }
        });
      });
  }


  wallet: any;
  availableBalance: any;
  totalBalance: any;
  reservedBalance: any;
  currentBalance: any;
  loadWallet() {
    this.dashboardService.walletExists(this.personID).subscribe({
      next: (res) => {
        this.wallet = res || 0;
        this.availableBalance = this.wallet!.data!.availableBalance || 0
        this.reservedBalance = this.wallet!.data!.reservedBalance || 0

        console.log('Wallet data:', this.wallet);
        this.getAvailablePercentage();
      },
      error: (err) => {
        console.error('Error fetching wallet:', err);
        this.wallet = null;
      }
    });
  }

  // getAvailablePercentage(): number {
  //   if (!this.wallet?.data) return 0;

  //   const available = this.wallet.data.availableBalance || 0;
  //   const total = this.wallet.data.reservedBalance || 1; // prevent division by zero

  //   return ((available / total) * 100);
  // }

  getAvailablePercentage(): number {
    if (!this.wallet?.data) return 0;

    const available = this.wallet.data.availableBalance || 0;
    const reserved = this.wallet.data.reservedBalance || 0;
    const total = available + reserved || 1; // prevent division by zero

    return Math.min((available / total) * 100, 100); // capped at 100%
  }

  get availableForDeals(): number {
    const available = this.wallet?.data?.availableBalance ?? 0;
    const reserved = this.wallet?.data?.reservedBalance ?? 0;

    const net = available - reserved;
    const finalValue = net <= 0 ? available : net;

    // Push latest value into service
    this.dashboardService.setAvailableForDeals(available);

    return available;
  }

  // async addFunds() {
  //   try {
  //     // 1️⃣ Create Stripe Payment Method
  //     const { paymentMethod, error } = await this.stripe.createPaymentMethod({
  //       type: 'card',
  //       card: this.card,
  //     });

  //     if (error) {
  //       console.error('Stripe error:', error);
  //       alert(error.message);
  //       return;
  //     }

  //     console.log('Payment Method ID:', paymentMethod.id);

  //     // 2️⃣ Determine if wallet exists
  //     const walletExists = !!this.availableAmount || !!this.spentAmount;

  //     // 3️⃣ Add or Topup wallet via service
  //     const response: any = await this.dashboardService.addOrTopUp(
  //       this.personID,
  //       this.userData.marketplace_id,
  //       this.amount,
  //       paymentMethod.id,
  //       walletExists
  //     );

  //     console.log('Wallet Topup Success:', response);

  //     // 4️⃣ Update UI
  //     this.availableAmount = (this.availableAmount || 0) + this.amount;
  //     alert('Funds added successfully!');
  //     this.closeAddFunds();

  //   } catch (err) {
  //     console.error('Error adding funds:', err);
  //     alert('Something went wrong while adding funds.');
  //   }
  // }
  private safeParse(value: string | null): any {
    try {
      return value ? JSON.parse(value) : '';
    } catch {
      return '';
    }
  }
}
